import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1028"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M14.796 4.463c.28-.34.455-.77.455-1.244a1.97 1.97 0 0 0-3.078-1.626A6.848 6.848 0 0 0 8.61.592a6.89 6.89 0 0 0-6.891 6.891c0 .823.152 1.609.417 2.341A2.943 2.943 0 0 0 .5 12.454a2.953 2.953 0 0 0 2.953 2.953 2.939 2.939 0 0 0 2.576-1.537 6.87 6.87 0 0 0 2.579.504 6.89 6.89 0 0 0 6.891-6.891 6.847 6.847 0 0 0-.703-3.02zM3.453 14.029a1.577 1.577 0 0 1-1.575-1.575c0-.869.707-1.575 1.575-1.575s1.575.707 1.575 1.575c0 .869-.706 1.575-1.575 1.575zM2.73 9.6l.047-.014-.047.014zm5.879 3.397a5.472 5.472 0 0 1-2.21-.466v.001c.001-.026.008-.051.008-.077a2.952 2.952 0 0 0-2.922-2.95 5.473 5.473 0 0 1-.389-2.02 5.52 5.52 0 0 1 5.513-5.513c1.012 0 1.957.279 2.773.756-.041.158-.07.321-.07.492 0 1.087.881 1.969 1.969 1.969.109 0 .214-.015.318-.032.332.708.523 1.495.523 2.328a5.52 5.52 0 0 1-5.513 5.512zm-2.328.264.014-.045-.014.045z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M8.57 4.685a2.688 2.688 0 1 0 0 5.376 2.688 2.688 0 0 0 0-5.376z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }